export default "__VITE_ASSET__BHitgaVx__"